/*!

=========================================================
* Argon Design System React - v1.1.2
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-design-system-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-design-system-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
// nodejs library that concatenates classes

// reactstrap components
import {
  Button,
  Card,
  CardBody,
  Container,
  Row,
  Col, Spinner,
} from "reactstrap";

// core components

// index page sections


import {RiAddLine, RiHeartFill, RiSettings3Line} from "react-icons/ri";
import withNavigateHook from "../../hooks/withNavigationHook";
import {useParams} from "react-router-dom";
import {sessionEnded} from "./SessionEnded";
import SongBooksDropdown from "../songbooks/SongBooksDropdown";
import {
  getSongBookPreferences, getThemePreferences,
  saveSongBookPreferences,
  saveThemePreferences
} from "../../components/helpers/UserPreferenceHelpers";
import Api from "../../components/helpers/Api";
import {RiDeleteBin6Line} from "@remixicon/react";
import SeoNoIndex from "../../components/helpers/SeoNoIndex";

class YourPreferencesSongBooks extends React.Component {
  state = {
    songBookCount: null,
    isLoading: false,
    listItems: [],
    songBookSelected: null,
  };

  componentDidMount() {
    this.setState({isLoading: true});
    Api.get(`/song-books`)
        .then(res => {
          const listItems = res.data;
          sessionStorage.setItem("songBooks", JSON.stringify(listItems));
          this.setState({listItems: listItems});
          this.setState({isLoading: false});
        })

    // This `if` statement is causing problems on reloading after deletion!
    // if (!sessionStorage.getItem("preferred-song-books")) {
    getSongBookPreferences().then(res => {

      const preferred = res || [];

      // Always sync sessionStorage with DB
      sessionStorage.setItem("preferred-song-books", JSON.stringify(preferred));

      const preferredSongBookIds = preferred.map(psb => psb.id);

      this.setState({
        chosenSongBooksButtons: preferred
            .sort((a, b) => a.title.localeCompare(b.title))
            .map((theme, index) =>
                this.showPill(index, theme, preferredSongBookIds)
            )
      });

    });
  }

  enableActiveButtonHandler = (enable) => {
    this.setState({activeButtonActive: enable});
    this.continueButtonAvailable();

    this.forceUpdate();
  }

  continueButtonAvailable = () => {
    sessionStorage.setItem("songBooksContinueEnabled", sessionStorage.getItem("preferred-song-books") && JSON.parse(sessionStorage.getItem("preferred-song-books")).length > 0);
  }

  updateSongBookPreferences = () => {
    const preferred = JSON.parse(sessionStorage.getItem("preferred-song-books")) || [];

    saveSongBookPreferences(preferred.map(psb => psb.id));
  }

  // componentDidMount() {
  //   this.setState({isLoading: true});
  //   Api.get(`/song-books`)
  //       .then(res => {
  //         const listItems = res.data;
  //         sessionStorage.setItem("songBooks", JSON.stringify(listItems));
  //         this.setState({listItems: listItems});
  //         this.setState({isLoading: false});
  //       })
  //
  //   const preferredSongBooks = sessionStorage.getItem("preferred-song-books") ? JSON.parse(sessionStorage.getItem("preferred-song-books")) : [];
  //   const preferredSongBookIds = sessionStorage.getItem("preferred-song-books") ? JSON.parse(sessionStorage.getItem("preferred-song-books")).map(psb => psb.id) : [];
  //   const songBooks = sessionStorage.getItem("preferred-song-books") == null ? [...preferredSongBooks] : [...JSON.parse(sessionStorage.getItem("preferred-song-books")), ...preferredSongBooks];
  //   this.setState({
  //     chosenSongBooksButtons: songBooks
  //         .sort((a, b) => a.title > b.title ? 1 : -1)
  //         .map((theme, index) => {
  //           return this.showPill(index, theme, preferredSongBookIds);
  //         })
  //   })
  // }

  changeSongBooksHandlerFrom = (event) => {
    const selectedOptions = Array.from(event.target.selectedOptions).map(option => option.value);
    const selectedSongBooks = this.state.listItems.filter(item => selectedOptions.includes(item.id));

    this.setState({ songBookSelected: selectedSongBooks });
  };


  addButtonAvailable = () => {
    return this.state.songBookSelected != null &&
        ((!sessionStorage.getItem("customer") && JSON.parse(sessionStorage.getItem("preferred-song-books"))?.length !== 1) ||
            (sessionStorage.getItem("customer")));
  }

  getAllSelected = () => {
    return sessionStorage.getItem("preferred-song-books") === null ? [] : JSON.parse(sessionStorage.getItem("preferred-song-books"));
  }

  addSongBooksToList = () => {
    const allSelected = this.getAllSelected();
    const newSelections = this.state.songBookSelected || [];

    newSelections.forEach(songBook => {
      const alreadyExists = allSelected.some(sb => sb.id === songBook.id);
      if (!alreadyExists) {
        allSelected.push({
          id: songBook.id,
          title: songBook.title,
          shortTitle: songBook.shortTitle,
        });
      }
    });

    sessionStorage.removeItem("selected-song-books")
    sessionStorage.setItem("preferred-song-books", JSON.stringify(allSelected));
    this.updateSongBookPreferences();

    this.enableActiveButtonHandler(true);
    sessionStorage.setItem("songBooksContinueEnabled", true);

    this.setState({
      chosenSongBooksButtons: allSelected
          .sort((a, b) => a.title.localeCompare(b.title))
          .map((theme, index) => this.showPill(index, theme, allSelected.map(sb => sb.id)))
    });
  }

  removeAllSongBooksFromList = () => {
    sessionStorage.removeItem("selected-song-books")
    sessionStorage.removeItem("preferred-song-books")

    this.updateSongBookPreferences();
  }


  removePill = (songBook) => {

    // Get current preferred books safely
    const preferred = JSON.parse(sessionStorage.getItem("preferred-song-books") || "[]");

    // Remove the selected book
    const updated = preferred.filter(sb => sb.id !== songBook.id);

    // Persist to sessionStorage
    sessionStorage.setItem("preferred-song-books", JSON.stringify(updated));

    // Update UI pills
    this.setState({
      chosenSongBooksButtons: updated
          .sort((a, b) => a.title.localeCompare(b.title))
          .map((theme, index) => this.showPill(index, theme, updated.map(sb => sb.id)))
    });

    // Persist to database
    this.updateSongBookPreferences();

    // Ensure UI updates correctly
    this.enableActiveButtonHandler(true);
  };

  showPill = (index, songBook, preferredSongBookIds) => {
    const showDeleteOption = window.location.pathname.includes("your-preferences");
    return (
        <div className="col-md-3 col-xs-12">
          <Button className='text-uppercase mx-2' color="primary" size="sm" style={{margin: '4px', width: "95%"}}
                  onClick={this.addButtonAvailable} title={songBook.title}>
                  <span style={{fontSize: "0.6rem"}}>
                      {this.showTitle(songBook)}
                  </span>&nbsp;
            {preferredSongBookIds && preferredSongBookIds.filter((val) => val.includes(songBook.id)).length >= 1
                ? showDeleteOption
                    ? <><a href="#" title={"Remove " + songBook.title + " from selected song books"}
                           onClick={(e) => { e.preventDefault(); this.removePill(songBook); }}
                           className="btn-inner--icon ml-1 mr-1"
                           style={{verticalAlign: "top"}}><RiDeleteBin6Line size={18} style={{
                      color: "white",
                      float: "right"
                    }}/></a><RiHeartFill size={18} style={{color: "white", float: "left"}}/></>
                    : <><RiHeartFill size={18} style={{color: "white", float: "right"}}/></>
                : <><a href="#" title={"Remove " + songBook.title + " from selected song books"}
                       onClick={(e) => { e.preventDefault(); this.removePill(songBook); }}
                       className="btn-inner--icon ml-1 mr-1"
                       style={{verticalAlign: "top"}}><RiDeleteBin6Line size={18} style={{
                  color: "white",
                  float: "right"
                }}/></a></>
            }
          </Button>
        </div>);
  }

  showTitle(songBook) {
    let titleToUse = songBook.title.length <= 20 ? songBook.title : !songBook.shortTitle ? songBook.title.substring(0, 19) + "..." : songBook.shortTitle;
    // console.log("[debug] using title " + titleToUse + ", title " + songBook.title + " (" + songBook.title.length + ") / shortTitle " + songBook.shortTitle);
    return <>
      {titleToUse}
    </>;
  }

  getSongBooksOptions() {
    const preferredSongBookIds = sessionStorage.getItem("preferred-song-books") ? JSON.parse(sessionStorage.getItem("preferred-song-books")).map(psb => psb.id) : [];

    return <>
      {
        this.state.listItems.map((listItem, index, array) => {
          const disabled = preferredSongBookIds.filter((val) => val.includes(listItem.id)).length >= 1;
          var option = <option disabled={disabled} key={listItem.id} className="dropdown-item" value={listItem.id}>{listItem.title}</option>;
          return <React.Fragment>
            {option}
          </React.Fragment>
        })
      }
    </>;
  }

  render() {
    if (!sessionStorage.getItem("customer")) {
      return sessionEnded();
    }

    return (
      <>
        <SeoNoIndex noindex={true} />

        {/*<main ref="main">*/}
          <div className="position-relative">
            {/* shape Hero */}
            <section className="section section-lg section-shaped pb-250">
              <div className="shape shape-style-1 shape-default">
                <span/>
                <span/>
                <span/>
                <span/>
                <span/>
                <span/>
                <span/>
                <span/>
                <span/>
              </div>
              <Container className="py-lg-md d-flex">
                <div className="col px-0">
                  <Row>
                    <Col lg="8">
                      <h1 className="display-3 text-white">
                        Building your song-flows{" "}
                        <span>your preferences</span>
                      </h1>
                      {/*<p className="lead text-white">*/}
                      {/*  The design system comes with four pre-built pages to*/}
                      {/*  help you get started faster. You can change the text and*/}
                      {/*  images and you're good to go.*/}
                      {/*</p>*/}
                    </Col>
                  </Row>
                </div>
              </Container>
              {/* SVG separator */}
              <div className="separator separator-bottom separator-skew">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    preserveAspectRatio="none"
                    version="1.1"
                    viewBox="0 0 2560 100"
                    x="0"
                    y="0"
                >
                  <polygon
                      className="fill-white"
                      points="2560 0 2560 100 0 100"
                  />
                </svg>
              </div>
            </section>
            {/* 1st Hero Variation */}
          </div>
          <section className="section section-lg pt-lg-0 mt--200">
            <Container>
              <Row className="justify-content-center">
                <Col lg="12">
                  <Row className="row-grid">
                    <Col lg="12">
                      <Card className="card-lift--hover shadow border-0">
                        <CardBody className="py-5">
                          <h2 style={{fontSize: '1rem'}} className="text-primary text-uppercase">
                            <RiSettings3Line color='#5e72e4' size="36"/>&nbsp;Your song book preferences
                          </h2>
                          <p className="description mt-3">
                            Personalise your song-flow creation by managing your song book preferences
                          </p>
                          <p className="description mt-3">
                            {/*<SongBooksDropdown key={new Date()}*/}
                            {/*                   enableActiveButtonHandler={this.enableActiveButtonHandler}*/}
                            {/*                   sessionPropName="preferred-song-books"*/}
                            {/*                   selectedTitle="Preselected Song Books:"/>*/}
                            <div>
                              <Row>
                                <div className="col-9 my-1">
                                  Song Books
                                </div>
                              </Row>
                              {
                                this.state.isLoading ?
                                    <p className="description mt-3">
                                      <div className="spinner-container">
                                        <Spinner animation="border" role="status">
                                          <span className="visually-hidden"></span>
                                        </Spinner>
                                        &nbsp;Loading...
                                      </div>
                                    </p>
                                    :
                                    <Row>
                                      <div className="col-md-9 my-3 col-xs-12">
                                        <select
                                            id="theme"
                                            className="custom-select"
                                            multiple
                                            onChange={e => this.changeSongBooksHandlerFrom(e)}
                                        >
                                          <option key="no-selection-made" disabled>
                                            Song Books ...
                                          </option>
                                          {this.getSongBooksOptions()}
                                        </select>
                                      </div>
                                      <div className="col-md-3 my-3 col-xs-12">
                                        <div className="btn-wrapper">
                                          <Button
                                              className="btn-icon mb-3 mb-sm-0 col-md-12 col-xs-12"
                                              color="primary"
                                              onClick={() => this.addSongBooksToList()}
                                              disabled={!this.addButtonAvailable()}
                                          >
                                            <RiAddLine/>
                                            <span className="btn-inner--text">Add</span>
                                          </Button>
                                        </div>
                                      </div>
                                    </Row>
                              }
                              <Row>
                                <div className="col-9 mt-3">
                                  <p>Preselected Song Books:</p>
                                  {this.state.chosenSongBooksButtons?.length
                                      ? <span></span>
                                      : <p>No selection made</p>
                                  }
                                </div>
                                <div className="col-3 mt-3">
                                  {this.state.chosenSongBooksButtons?.length
                                      ?                                           <Button
                                          className="btn-icon mb-3 mb-sm-0 col-md-12 col-xs-12"
                                          color="primary"
                                          onClick={() => this.removeAllSongBooksFromList()}
                                      >
                                        <RiAddLine/>
                                        <span className="btn-inner--text">Remove all</span>
                                      </Button>

                                      : <></>
                                  }
                                </div>
                                {
                                  this.state.chosenSongBooksButtons
                                }
                              </Row>
                            </div>
                            <Row>
                              <Col lg="2">
                                <div className="btn-wrapper">
                                </div>
                              </Col>
                              {/*<Col lg="8">*/}
                              {/*  <div className="btn-wrapper">*/}
                              {/*    <Button*/}
                              {/*        type="submit"*/}
                              {/*        id="continueButton"*/}
                              {/*        className="btn-icon mb-3 mb-sm-0 mt-5"*/}
                              {/*        color="primary"*/}
                              {/*        onClick={() => this.updateSongBookPreferences()}*/}
                              {/*    >*/}
                              {/*      <span className="btn-inner--text">Update Your Song Book Preferences</span>*/}
                              {/*    </Button>*/}
                              {/*  </div>*/}
                              {/*</Col>*/}
                              <Col lg="2">
                                <div className="btn-wrapper">
                                </div>
                              </Col>
                            </Row>
                          </p>
                        </CardBody>
                      </Card>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Container>
          </section>
        {/*</main>*/}

      </>
    );
  }
}

export default withNavigateHook((props) => (
    <YourPreferencesSongBooks{...props} params={useParams()}/>
));
